export enum PageSlug {
  Help = "help",
  HelpGeneral = "help-general",
  HelpSiab = "help-siab",
  HelpRegistry = "help-registry",
  HelpEshop = "help-eshop",
  HelpMarketingAndMaterial = "help-marketing-and-material",
  HelpSupport = "help-support",
  HelpClearCorrect = "help-clearcorrect",
  CustomerReleases = "sales-axs-customer-releases-2",
  SalesReleases = "sales-axs-releases-2",
  UploadingGuide = "uploading-guide",
  SalesAxsDisruption = "sales-axs-disruption",
  AxsDisruption = "axs-disruption",
  ClearCorrect = "clear-correct",
  CoDianostix = "codiagnostix",
  ContactInfo = "contact-info",
  Dashboard = "dashboard",
  HelpSignin = "help-signin",
  HowToCompresszipFiles = "compress-files",
  MeditIos = "medit-ios",
  Network = "network",
  Onboarding = "onboarding",
  Registry = "implant-registry",
  Releases = "releases-2",
  Smilecloud = "smilecloud",
  SmileInABox = "smile-in-a-box",
  ThreeShapeTrios = "3shape-trios",
  UploadRecords = "upload-records",
  VirtuoVivo = "virtuo-vivo",
}
